import { ShieldCheck } from "lucide-react";

export function OwnerAccessCard({ sub, usage }) {
  return (
    <div className="sc-card p-6 border-emerald-700/50" data-testid="owner-access-card">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <div className="label-cap text-emerald-400 flex items-center gap-2"><ShieldCheck className="w-4 h-4" /> INTERNAL WORKSPACE</div>
          <h2 className="font-heading text-xl font-extrabold text-slate-100 mt-1" data-testid="owner-access-label">{sub.label}</h2>
          <div className="text-sm text-slate-400 mt-1">Billing: <span className="text-emerald-400 font-semibold" data-testid="owner-access-billing">{sub.billing}</span> · no Stripe subscription, trial or payment method. Usage here is excluded from customer revenue and conversion metrics; operating cost is still tracked.</div>
        </div>
        <div className="grid grid-cols-3 gap-3 text-center">
          {[["Active projects", usage.active_projects], ["AI reviews (period)", usage.ai_reviews], ["Est. AI cost", `$${usage.est_cost_usd}`]].map(([l, v]) => (
            <div key={l} className="bg-slate-950/60 border border-slate-800 rounded-md px-3 py-2"><div className="font-mono text-lg text-slate-100">{v}</div><div className="text-[11px] uppercase tracking-wider text-slate-500">{l}</div></div>
          ))}
        </div>
      </div>
    </div>
  );
}
